import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import { CalendarBlankIcon, ShareNetworkIcon, UsersThreeIcon } from "@phosphor-icons/react";
import { SectionEyebrow } from "@scoutingops/ui";

const items = [
  {
    icon: <CalendarBlankIcon size={22} />,
    title: "Built on Calendar",
    desc: "Publish an event once in Scouting Ops Calendar and it shows up on your public site automatically — no double entry.",
  },
  {
    icon: <UsersThreeIcon size={22} />,
    title: "Unit-aware",
    desc: "Sites are scoped to your organization. Different units, different data — always separate.",
  },
  {
    icon: <ShareNetworkIcon size={22} />,
    title: "Cross-app by design",
    desc: "As Community, Sign-ups, and Forms come online, the same data will be what your site publishes to families.",
  },
];

export default function PlatformContextSection() {
  return (
    <Box sx={{ bgcolor: "background.paper", py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        <Grid container spacing={6} sx={{ alignItems: "center" }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ mb: 1.5 }}>
              <SectionEyebrow align="left">Part of the Scouting Ops Platform</SectionEyebrow>
            </Box>
            <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
              Site is your unit&apos;s front door
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.7 }}>
              Scouting Ops is building the complete operating system for Scouting organizations.
              Site is where the rest of the platform becomes visible to the outside world: the
              events your leaders schedule, the program your unit runs, and the way families find
              and join you.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
              As the platform grows, publishing to your site will be a byproduct of the operational
              work your unit already does elsewhere — instead of a separate task someone has to
              remember.
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Stack spacing={3}>
              {items.map((item) => (
                <Box key={item.title} sx={{ display: "flex", gap: 2 }}>
                  <Box
                    sx={{
                      color: "primary.main",
                      bgcolor: "action.selected",
                      borderRadius: 1.5,
                      p: 1,
                      height: 40,
                      width: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.desc}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
